import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Col, Input, Row } from "reactstrap";
import Loader from "./Loader";
import { useSelector } from "react-redux";

const tableCustomStyle = {
    table: {
        style: {
            height: "500px",
        },
    },
    headCells: {
        style: {
            width: "130px",
            justifyContent: "center",
            // backgroundColor: '#dbdde0',
            fontWeight: "700",
            fontSize: "small",
            fontFamily: "Arial, Helvetica, sans-serif",
            background: "red",
        },
    },
    cells: {
        style: {
            fontWeight: "500",
            width: "150px",
            fontSize: "small",
            justifyContent: "center",
            fontFamily: "Arial, Helvetica, sans-serif",
        },
    },
    headRow: {
        style: {
            borderTop: "1px solid #ddd",
            background: "#fff2f2",
            fontWeight: "600",
            borderRight: "1px solid #ddd",
        },
    },
    headCells: {
        style: {
            borderRight: "1px solid #fff2f2",
            borderLeft: "1px solid #ddd",
            borderBottom: "1px solid #fff2f2",
        },
    },

    cells: {
        style: {
            borderRight: "1px solid #fff",
            borderLeft: "1px solid #ddd",
            "&:first-child": {
                borderLeft: "1px solid #ddd",
            },
            "&:last-child": {
                borderRight: "1px solid #ddd",
            },
        },
    },
};

const commantableCustomStyle = {
    table: {
        style: {
            height: "750px",
        },
    },
    headCells: {
        style: {
            width: "130px",
            justifyContent: "center",
            // backgroundColor: '#dbdde0',
            fontWeight: "700",
            fontSize: "small",
            fontFamily: "Arial, Helvetica, sans-serif",
            background: "red",
        },
    },
    cells: {
        style: {
            fontWeight: "500",
            width: "150px",
            fontSize: "small",
            justifyContent: "center",
            fontFamily: "Arial, Helvetica, sans-serif",
        },
    },
    headRow: {
        style: {
            borderTop: "1px solid #ddd",
            background: "#fff2f2",
            fontWeight: "600",
            borderRight: "1px solid #ddd",
        },
    },
    headCells: {
        style: {
            borderRight: "1px solid #fff2f2",
            borderLeft: "1px solid #ddd",
            borderBottom: "1px solid #fff2f2",
        },
    },

    cells: {
        style: {
            borderRight: "1px solid #fff",
            borderLeft: "1px solid #ddd",
            "&:first-child": {
                borderLeft: "1px solid #ddd",
            },
            "&:last-child": {
                borderRight: "1px solid #ddd",
            },
        },
    },
};


const DashboardDataTable = ({ column, tableData, currentPage }) => {
    const paginationComponentOptions = {
        rowsPerPageText: 'Rows per page:',
        rangeSeparatorText: 'of',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'All',
        rowsPerPageOptions: [10, -1],
    };
    const [tableKey, setTableKey] = useState(0);

    useEffect(() => {
        setTableKey((prevKey) => prevKey + 1);
    }, [tableData, currentPage]);

    return (
        <Row className="n-tble-home-page">
            <Col lg={12}>
                <DataTable
                    key={tableKey}
                    customStyles={tableCustomStyle}
                    columns={column}
                    data={tableData}
                    pagination
                    paginationComponentOptions={paginationComponentOptions}
                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                    paginationPerPage={10}
                />
            </Col>
        </Row>
    );
};

const CommanDataTables = ({ column, tableData, searchText, inputClass, handleSearch, isLoading, currentPage, onSelectedRowsChange,
    selectableRows, selectableRowDisabled }) => {

    const paginationComponentOptions = {
        rowsPerPageText: 'Rows per page:',
        rangeSeparatorText: 'of',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'All',
        rowsPerPageOptions: [10, -1], // -1 represents "All"
    };

    const [tableKey, setTableKey] = useState(0);
    const email = useSelector((state) => state.Login.user.email);

    useEffect(() => {
      if (email !== "superadmin@gmail.com") {
        setTableKey((prevKey) => prevKey + 1);
      }
    }, [tableData, currentPage, email]);

    return (
        <>
            <div className='custom-datatable'>
                <Row className='g-3 mt-0'>
                    <Col xxl={2} md={4} className='ms-auto'>
                        <Input
                            value={searchText}
                            type="text"
                            className={`form-control ${inputClass}`}
                            id="exampleInputrounded"
                            placeholder="Search by keyword..."
                            onChange={handleSearch}
                        />
                    </Col>
                    <Col lg={12} className='sn-tble-call-archive-mainn sn-team-number--employyes-btn sn-tble-bottom-scroll-main sn-total-calltype-btn-status sn-employee-managment-tble-detail' style={{ textAlign: 'center', overflow: 'scroll' }}>
                        <Col lg={12}>
                            <DataTable
                                selectableRows={selectableRows}
                                selectableRowDisabled={selectableRowDisabled}
                                selectableRowsVisibleOnly={true}
                                onSelectedRowsChange={onSelectedRowsChange}
                                key={tableKey}
                                paginationComponentOptions={paginationComponentOptions}
                                progressPending={isLoading}
                                progressComponent={<Loader />}
                                fixedHeader
                                customStyles={commantableCustomStyle}
                                columns={column}
                                data={tableData}
                                pagination
                                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                            />
                        </Col>
                    </Col>
                </Row>
            </div>

        </>
    );
};


const LeadDataTable = ({ onChangePage, onChangeRowsPerPage, paginationTotalRows, data, columns, progressPending }) => {

    return (
        <>
            <div className="flex-grow-1 ms-2">
                <div className="sn-lead-report-management-tble-ui">
                    <DataTable
                        customStyles={tableCustomStyle}
                        defaultSortAsc={true}
                        columns={columns}
                        data={data}
                        fixedHeaderScrollHeight="400px"
                        fixedHeader
                        striped
                        pagination
                        paginationServer
                        paginationTotalRows={paginationTotalRows}
                        paginationRowsPerPageOptions={[10, 25, 50, 100]}
                        paginationComponentOptions={{ rowsPerPageText: "Rows per page" }}
                        responsive
                        progressPending={progressPending}
                        progressComponent={<Loader />}
                        onChangePage={onChangePage} // ✅ Pass tabId properly
                        onChangeRowsPerPage={onChangeRowsPerPage} // ✅ Ensure per-page updates correctly
                    />
                </div>
            </div>
        </>
    )
}

export { DashboardDataTable, CommanDataTables, LeadDataTable }
